/**
 * Campo ausente/pendente — ÍCONE + TEXTO, nunca só cor (régua §2 / WCAG 1.4.1).
 *
 * Redesign R6 (FEAT-002, apresentação apenas): substitui a classe legada
 * `.field--pending` (compat em styles.css) por utilitárias tokenizadas nas
 * telas de pedidos/expedição. O rótulo do próprio campo já diz o que falta; o
 * ícone de alerta reforça o estado e a cor vem do token `brand-text` (reforço,
 * não a informação).
 *
 * PRESERVA o contrato que os testes verificam: o hook `data-pending="true"`
 * segue no span e o TEXTO do rótulo é renderizado como está. A classe hook
 * `field--pending` é mantida no markup como gancho estável, mas sem CSS legado
 * concorrendo (o estilo agora vem das utilitárias).
 */
import { createElement as h, type ReactElement, type ReactNode } from "react";
import { TriangleAlert } from "lucide-react";

export function PendingField({ label }: { label: ReactNode }): ReactElement {
  return h(
    "span",
    {
      className: "field--pending inline-flex items-center gap-1 font-semibold text-brand-text",
      "data-pending": "true"
    },
    h(TriangleAlert, { className: "h-3.5 w-3.5 shrink-0", "aria-hidden": true, focusable: false }),
    h("span", null, label)
  );
}
